export default "__VITE_ASSET__Cgqqs459__"